var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 2.18312H13.25V1.42554C13.25 1.00888 12.9125 0.667969 12.5 0.667969C12.0875 0.667969 11.75 1.00888 11.75 1.42554V2.18312H4.25V1.42554C4.25 1.00888 3.9125 0.667969 3.5 0.667969C3.0875 0.667969 2.75 1.00888 2.75 1.42554V2.18312H2C1.175 2.18312 0.5 2.86494 0.5 3.69827V15.8195C0.5 16.6528 1.175 17.3346 2 17.3346H14C14.825 17.3346 15.5 16.6528 15.5 15.8195V3.69827C15.5 2.86494 14.825 2.18312 14 2.18312ZM13.25 15.8195H2.75C2.3375 15.8195 2 15.4786 2 15.0619V5.971H14V15.0619C14 15.4786 13.6625 15.8195 13.25 15.8195Z",
    fill: "#FFEDDC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/Calendar.ae8e1aa26903bc0e4b7d0a333a13051a.svg";
export { ForwardRef as ReactComponent };